import { useState, useEffect } from 'react';
import { SummaryTable } from 'src/Components/Organisms';
import Card, { CardContent, CardTitle } from "src/MarketDataComponents/Card";
import { formatMillions } from 'src/Utils';
import { formatNumber } from "src/MarketDataComponents/Helpers";
import Link from 'next/link';

export const format = (element, parseAsFloat, number) => {
    if (element && element !== 'n/a') {
        return number ? formatNumber(element, 2) : formatMillions(parseAsFloat ? parseFloat(element) : element);
    }

    return '-';
}

export default function BalanceSheet({balanceSheet, quote}) {

    const [balanceSheets, setBalanceSheets] = useState([]);
    const [currency, setCurrency] = useState(null);

    useEffect(() => {
        const balanceSheetFormatted = [];
        let balanceSheetCurrency = null;

        balanceSheet.reverse().forEach((period) => {
            balanceSheetCurrency = period.currency;
            balanceSheetFormatted.push({
                label: period.yearEnd ? period.yearEnd.split('-')[0] : '',
                values: {
                    totalAssets: format(period.assets.totalAssets),
                    totalLiabilities: format(period.liabilities.totalLiabilities),
                    totalDebt: format(period.totalBorrowings, true),
                    totalEquity: format(period.equity.totalCapitalEmployed),
                    cash: format(period.assets.cashAndEquivalents)
                }
            });
        });

        setCurrency(balanceSheetCurrency);
        setBalanceSheets(balanceSheetFormatted);
    }, []);

    return <>
        {balanceSheets && balanceSheets.length ? <Card>
            <h2 className="h4 margin-bottom-0" data-testid="balanceSheetTableHeader">Balance sheet</h2>
            <CardContent>
                <SummaryTable 
                    periods={balanceSheets}
                    categories={{
                        totalAssets: "Total assets",
                        totalLiabilities: "Total liabilities",
                        totalDebt: "Total debt",
                        totalEquity: "Total equity",
                        cash: "Cash and cash equivalents"
                    }}
                />
                <Link href={`/sub/${quote.marketCode}/financials/balance-sheet`} data-testid="balanceSheetMoreLink">More</Link>
            </CardContent>
        </Card>: null}
    </>

}
